/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import * as HierarchiesAPI from '../services/HierarchiesAPI';
import {
  LoadLocationsForSiteType,
  LoadOrganizationByIdType,
  LoadOrganizationsType,
  LoadSiteByIdType,
  LoadSitesForOrganizationType,
  LoadSystemsForSiteType,
  LoadSystemsForSiteLocationType,
  LoadSystemByIdForSiteType,
  LoadLocationsForSystemType,
  LoadLocationByIdForSiteType,
  LoadParentLocationsForLocationType,
  LoadSublocationsForSystemType,
  LoadAssetForSiteLocationType,
  LoadAssetsForSiteType,
  LoadAssetByIdForSite,
  LoadParentAssetsForAssetType,
  LoadSubAssetsForAssetType,
  LoadDeviceTypesType,
  LoadDeviceTypeById,
  DeviceTypeResourceType,
  UpdateV1DeviceTypeType,
  UpdateDeviceAliasType,
  LoadDevicesForDeviceTypeType,
  LoadDimensionsForDeviceTypeType,
  UpdateDimensionsForDeviceTypeType,
  DeleteDimensionsForDeviceTypeType,
  AddDimensionsForDeviceTypeType,
  AddDevicesForDeviceTypeType,
  UpdateDimensionsForDeviceType,
  AddDimensionsForDeviceType,
  LoadDimensionsForDeviceType,
  LoadDevicesForLocationType,
  LoadDeviceDetailsType,
  LoadAssetTypesType,
  LoadAssetsForAssetTypeType,
  PersistHierarchyTableType,
  LoadDevicesForAssetType,
  LoadDevicesWithDimensionsType,
  DeleteMetricsForDeviceTypeType,
  UpdateV2DeviceTypeType,
} from '../types/HierarchyActionTypes';
import { createDevicesForDeviceTypeAPI } from '../services/V2DeviceTypeAPI';

import { getDeviceDetails, getDeviceDetailsWithDimensions } from 'DatalakeAPI';
import { CommonActionType, ErrorType, I18NErrorType } from 'CommonTypes';
import { DimensionsType, EntityType, AddDevicesPayloadType } from 'EntitiesTypes';
import { filterUserResourcesToArray, filterUserResourcesToObject } from 'Utils';
import { RESOURCE_TYPES } from 'dataConstants';
import { AppThunk } from 'store';

// Organization
export const GET_ORGANIZATIONS_DATA = 'GET_ORGANIZATIONS_DATA';
export const GET_ORGANIZATIONS_DATA_FAILURE = 'GET_ORGANIZATIONS_DATA_FAILURE';
export const GET_ORGANIZATIONS_DATA_SUCCESS = 'GET_ORGANIZATIONS_DATA_SUCCESS';

// org by id
export const GET_ORGANIZATION_BY_ID_DATA = 'GET_ORGANIZATION_BY_ID_DATA';
export const GET_ORGANIZATION_BY_ID_DATA_FAILURE = 'GET_ORGANIZATION_BY_ID_DATA_FAILURE';
export const GET_ORGANIZATION_BY_ID_DATA_SUCCESS = 'GET_ORGANIZATION_BY_ID_DATA_SUCCESS';

// Site of organization
export const GET_SITES_FOR_ORGANIZATION_DATA = 'GET_SITES_FOR_ORGANIZATION_DATA';
export const GET_SITES_FOR_ORGANIZATION_DATA_FAILURE = 'GET_SITES_FOR_ORGANIZATION_DATA_FAILURE';
export const GET_SITES_FOR_ORGANIZATION_DATA_SUCCESS = 'GET_SITES_FOR_ORGANIZATION_DATA_SUCCESS';

// Site details
export const GET_SITE_DATA = 'GET_SITE';
export const GET_SITE_DATA_FAILURE = 'GET_SITE_FAILURE';
export const GET_SITE_DATA_SUCCESS = 'GET_SITE_DATA_SUCCESS';

// Systems of site
export const GET_SYSTEMS_FOR_SITE_DATA = 'GET_SYSTEMS_FOR_SITE_DATA';
export const GET_SYSTEMS_FOR_SITE_DATA_FAILURE = 'GET_SYSTEMS_FOR_SITE_DATA_FAILURE';
export const GET_SYSTEMS_FOR_SITE_DATA_SUCCESS = 'GET_SYSTEMS_FOR_SITE_DATA_SUCCESS';

// Systems of site and location
export const GET_SYSTEMS_FOR_SITE_LOCATION_DATA = 'GET_SYSTEMS_FOR_SITE_LOCATION_DATA';
export const GET_SYSTEMS_FOR_SITE_LOCATION_DATA_FAILURE =
  'GET_SYSTEMS_FOR_SITE_LOCATION_DATA_FAILURE';
export const GET_SYSTEMS_FOR_SITE_LOCATION_DATA_SUCCESS =
  'GET_SYSTEMS_FOR_SITE_LOCATION_DATA_SUCCESS';

// Locations of site
export const GET_LOCATIONS_FOR_SITE_DATA = 'GET_LOCATIONS_FOR_SITE_DATA';
export const GET_LOCATIONS_FOR_SITE_DATA_FAILURE = 'GET_LOCATIONS_FOR_SITE_DATA_FAILURE';
export const GET_LOCATIONS_FOR_SITE_DATA_SUCCESS = 'GET_LOCATIONS_FOR_SITE_DATA_SUCCESS';

// system by system id
export const GET_SYSTEM_BY_ID_FOR_SITE_DATA = 'GET_SYSTEM_BY_ID_FOR_SITE_DATA';
export const GET_SYSTEM_BY_ID_FOR_SITE_DATA_FAILURE = 'GET_SYSTEM_BY_ID_FOR_SITE_DATA_FAILURE';
export const GET_SYSTEM_BY_ID_FOR_SITE_DATA_SUCCESS = 'GET_SYSTEM_BY_ID_FOR_SITE_DATA_SUCCESS';

// Locations of system
export const GET_LOCATIONS_FOR_SYSTEM_DATA = 'GET_LOCATIONS_FOR_SYSTEM_DATA';
export const GET_LOCATIONS_FOR_SYSTEM_DATA_FAILURE = 'GET_LOCATIONS_FOR_SYSTEM_DATA_FAILURE';
export const GET_LOCATIONS_FOR_SYSTEM_DATA_SUCCESS = 'GET_LOCATIONS_FOR_SYSTEM_DATA_SUCCESS';

// Locations by id for site
export const GET_LOCATION_BY_ID_FOR_SITE_DATA = 'GET_LOCATION_BY_ID_FOR_SITE_DATA';
export const GET_LOCATION_BY_ID_FOR_SITE_DATA_FAILURE = 'GET_LOCATION_BY_ID_FOR_SITE_DATA_FAILURE';
export const GET_LOCATION_BY_ID_FOR_SITE_DATA_SUCCESS = 'GET_LOCATION_BY_ID_FOR_SITE_DATA_SUCCESS';

// Location parent
export const GET_PARENT_LOCATIONS_FOR_LOCATION_DATA = 'GET_PARENT_LOCATIONS_FOR_LOCATION_DATA';
export const GET_PARENT_LOCATIONS_FOR_LOCATION_DATA_FAILURE =
  'GET_PARENT_LOCATIONS_FOR_LOCATION_DATA_FAILURE';
export const GET_PARENT_LOCATIONS_FOR_LOCATION_DATA_SUCCESS =
  'GET_PARENT_LOCATIONS_FOR_LOCATION_DATA_SUCCESS';
export const CLEAR_PARENT_LOCATIONS = 'CLEAR_PARENT_LOCATIONS';

// Sublocation of system

export const GET_SUBLOCATIONS_FOR_SYSTEM_DATA = 'GET_SUBLOCATIONS_FOR_SYSTEM_DATA';
export const GET_SUBLOCATIONS_FOR_SYSTEM_DATA_FAILURE = 'GET_SUBLOCATIONS_FOR_SYSTEM_DATA_FAILURE';
export const GET_SUBLOCATIONS_FOR_SYSTEM_DATA_SUCCESS = 'GET_SUBLOCATIONS_FOR_SYSTEM_DATA_SUCCESS';

// Assets types
export const GET_ASSET_TYPES_DATA = 'GET_ASSET_TYPES_DATA';
export const GET_ASSET_TYPES_DATA_FAILURE = 'GET_ASSET_TYPES_DATA_FAILURE';
export const GET_ASSET_TYPES_DATA_SUCCESS = 'GET_ASSET_TYPES_DATA_SUCCESS';

// Assets for asset type
export const GET_ASSETS_FOR_ASSET_TYPE_DATA = 'GET_ASSETS_FOR_ASSET_TYPE_DATA';
export const GET_ASSETS_FOR_ASSET_TYPE_DATA_FAILURE = 'GET_ASSETS_FOR_ASSET_TYPE_DATA_FAILURE';
export const GET_ASSETS_FOR_ASSET_TYPE_DATA_SUCCESS = 'GET_ASSETS_FOR_ASSET_TYPE_DATA_SUCCESS';
export const CLEAR_ASSETS_FOR_ASSET_TYPE = 'CLEAR_ASSETS_FOR_ASSET_TYPE';

export const GET_ASSETS_FOR_LOCATION_DATA = 'GET_ASSETS_FOR_LOCATION_DATA';
export const GET_ASSETS_FOR_LOCATION_DATA_FAILURE = 'GET_ASSETS_FOR_LOCATION_DATA_FAILURE';
export const GET_ASSETS_FOR_LOCATION_DATA_SUCCESS = 'GET_ASSETS_FOR_LOCATION_DATA_SUCCESS';

export const GET_ASSETS_FOR_SITE_DATA = 'GET_ASSETS_FOR_SITE_DATA';
export const GET_ASSETS_FOR_SITE_DATA_FAILURE = 'GET_ASSETS_FOR_SITE_DATA_FAILURE';
export const GET_ASSETS_FOR_SITE_DATA_SUCCESS = 'GET_ASSETS_FOR_SITE_DATA_SUCCESS';

export const GET_ASSET_BY_ID_FOR_SITE_DATA = 'GET_ASSET_BY_ID_FOR_SITE_DATA';
export const GET_ASSET_BY_ID_FOR_SITE_DATA_FAILURE = 'GET_ASSET_BY_ID_FOR_SITE_DATA_FAILURE';
export const GET_ASSET_BY_ID_FOR_SITE_DATA_SUCCESS = 'GET_ASSET_BY_ID_FOR_SITE_DATA_SUCCESS';

export const GET_PARENT_ASSETS_FOR_ASSET_DATA = 'GET_PARENT_ASSETS_FOR_ASSET_DATA';
export const GET_PARENT_ASSETS_FOR_ASSET_DATA_FAILURE = 'GET_PARENT_ASSETS_FOR_ASSET_DATA_FAILURE';
export const GET_PARENT_ASSETS_FOR_ASSET_DATA_SUCCESS = 'GET_PARENT_ASSETS_FOR_ASSET_DATA_SUCCESS';
export const CLEAR_PARENT_ASSETS = 'CLEAR_PARENT_ASSETS';

export const GET_SUBASSETS_FOR_ASSET_DATA = 'GET_SUBASSETS_FOR_ASSET_DATA';
export const GET_SUBASSETS_FOR_ASSET_DATA_FAILURE = 'GET_SUBASSETS_FOR_ASSET_DATA_FAILURE';
export const GET_SUBASSETS_FOR_ASSET_DATA_SUCCESS = 'GET_SUBASSETS_FOR_ASSET_DATA_SUCCESS';
export const CLEAR_SUBASSETS = 'CLEAR_SUBASSETS';

export const GET_DEVICES_FOR_ASSET_DATA = 'GET_DEVICES_FOR_ASSET_DATA';
export const GET_DEVICES_FOR_ASSET_DATA_FAILURE = 'GET_DEVICES_FOR_ASSET_DATA_FAILURE';
export const GET_DEVICES_FOR_ASSET_DATA_SUCCESS = 'GET_DEVICES_FOR_ASSET_DATA_SUCCESS';

// Device types
export const GET_DEVICE_TYPES_DATA = 'GET_DEVICE_TYPES_DATA';
export const GET_DEVICE_TYPES_DATA_FAILURE = 'GET_DEVICE_TYPES_DATA_FAILURE';
export const GET_DEVICE_TYPES_DATA_SUCCESS = 'GET_DEVICE_TYPES_DATA_SUCCESS';

// update device type
export const UPDATE_DEVICE_TYPE_DATA = 'UPDATE_DEVICE_TYPE_DATA';
export const UPDATE_DEVICE_TYPE_DATA_FAILURE = 'UPDATE_DEVICE_TYPE_DATA_FAILURE';
export const UPDATE_DEVICE_TYPE_DATA_SUCCESS = 'UPDATE_DEVICE_TYPE_DATA_SUCCESS';

// Device Type details
export const GET_DEVICE_TYPE_DATA = 'GET_DEVICE_TYPE_DATA';
export const GET_DEVICE_TYPE_DATA_FAILURE = 'GET_DEVICE_TYPE_DATA_FAILURE';
export const GET_DEVICE_TYPE_DATA_SUCCESS = 'GET_DEVICE_TYPE_DATA_SUCCESS';

// Device Alias
export const UPDATE_DEVICE_ALIAS = 'UPDATE_DEVICE_ALIAS';
export const UPDATE_DEVICE_ALIAS_FAILURE = 'UPDATE_DEVICE_ALIAS_FAILURE';
export const UPDATE_DEVICE_ALIAS_SUCCESS = 'UPDATE_DEVICE_ALIAS_SUCCESS';

// Device Details
export const GET_DEVICE_DETAILS_DATA = 'GET_DEVICE_DETAILS_DATA';
export const GET_DEVICE_DETAILS_DATA_FAILURE = 'GET_DEVICE_DETAILS_DATA_FAILURE';
export const GET_DEVICE_DETAILS_DATA_SUCCESS = 'GET_DEVICE_DETAILS_DATA_SUCCESS';

// Devices for device type
export const GET_DEVICES_FOR_DEVICE_TYPE_DATA = 'GET_DEVICES_FOR_DEVICE_TYPE_DATA';
export const GET_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE = 'GET_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE';
export const GET_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS = 'GET_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS';
export const CLEAR_DEVICES_FOR_DEVICE_TYPE = 'CLEAR_DEVICES_FOR_DEVICE_TYPE';
export const CREATE_DEVICES_FOR_DEVICE_TYPE_DATA = 'CREATE_DEVICES_FOR_DEVICE_TYPE_DATA';
export const CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE =
  'CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE';
export const CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS =
  'CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS';

// Dimensions for device type
export const GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA = 'GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA';
export const GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_FAILURE =
  'GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_FAILURE';
export const GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_SUCCESS =
  'GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_SUCCESS';
export const CLEAR_DIMENSIONS_FOR_DEVICE_TYPE = 'CLEAR_DIMENSIONS_FOR_DEVICE_TYPE';
export const UPDATE_DIMENSIONS_FOR_DEVICE_TYPE = 'UPDATE_DIMENSIONS_FOR_DEVICE_TYPE';
export const UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS =
  'UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS';
export const UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE =
  'UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE';
export const CREATE_DIMENSIONS_FOR_DEVICE_TYPE = 'CREATE_DIMENSIONS_FOR_DEVICE_TYPE';
export const CREATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS =
  'CREATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS';
export const CREATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE =
  'CREATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE';
export const DELETE_DIMENSIONS_FOR_DEVICE_TYPE = 'DELETE_DIMENSIONS_FOR_DEVICE_TYPE';
export const DELETE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS =
  'DELETE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS';
export const DELETE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE =
  'DELETE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE';

// Metrics for device type
export const UPDATE_METRICS_FOR_DEVICE_TYPE = 'UPDATE_METRICS_FOR_DEVICE_TYPE';
export const UPDATE_METRICS_FOR_DEVICE_TYPE_SUCCESS = 'UPDATE_METRICS_FOR_DEVICE_TYPE_SUCCESS';
export const UPDATE_METRICS_FOR_DEVICE_TYPE_FAILURE = 'UPDATE_METRICS_FOR_DEVICE_TYPE_FAILURE';
export const DELETE_METRICS_FOR_DEVICE_TYPE = 'DELETE_METRICS_FOR_DEVICE_TYPE';
export const DELETE_METRICS_FOR_DEVICE_TYPE_SUCCESS = 'DELETE_METRICS_FOR_DEVICE_TYPE_SUCCESS';
export const DELETE_METRICS_FOR_DEVICE_TYPE_FAILURE = 'DELETE_METRICS_FOR_DEVICE_TYPE_FAILURE';

// Dimensions for device
export const UPDATE_DIMENSIONS_FOR_DEVICE = 'UPDATE_DIMENSIONS_FOR_DEVICE';
export const UPDATE_DIMENSIONS_FOR_DEVICE_FAILURE = 'UPDATE_DIMENSIONS_FOR_DEVICE_FAILURE';
export const UPDATE_DIMENSIONS_FOR_DEVICE_SUCCESS = 'UPDATE_DIMENSIONS_FOR_DEVICE_SUCCESS';
export const CREATE_DIMENSIONS_FOR_DEVICE = 'CREATE_DIMENSIONS_FOR_DEVICE';
export const CREATE_DIMENSIONS_FOR_DEVICE_FAILURE = 'CREATE_DIMENSIONS_FOR_DEVICE_FAILURE';
export const CREATE_DIMENSIONS_FOR_DEVICE_SUCCESS = 'CREATE_DIMENSIONS_FOR_DEVICE_SUCCESS';
export const GET_DIMENSIONS_FOR_DEVICE = 'GET_DIMENSIONS_FOR_DEVICE';
export const GET_DIMENSIONS_FOR_DEVICE_FAILURE = 'GET_DIMENSIONS_FOR_DEVICE_FAILURE';
export const GET_DIMENSIONS_FOR_DEVICE_SUCCESS = 'GET_DIMENSIONS_FOR_DEVICE_SUCCESS';

// Devices for specific site and location
export const GET_DEVICES_FOR_LOCATION_DATA = 'GET_DEVICES_FOR_LOCATION_DATA';
export const GET_DEVICES_FOR_LOCATION_DATA_FAILURE = 'GET_DEVICES_FOR_LOCATION_DATA_FAILURE';
export const GET_DEVICES_FOR_LOCATION_DATA_SUCCESS = 'GET_DEVICES_FOR_LOCATION_DATA_SUCCESS';
export const CLEAR_HIERARCHIES = 'CLEAR_HIERARCHIES';

// Devices with dimensions data
export const GET_DEVICE_DIMENSIONS_DATA = 'GET_DEVICE_DIMENSIONS_DATA';
export const GET_DEVICE_DIMENSIONS_DATA_FAILURE = 'GET_DEVICE_DIMENSIONS_DATA_FAILURE';
export const GET_DEVICE_DIMENSIONS_DATA_SUCCESS = 'GET_DEVICE_DIMENSIONS_DATA_SUCCESS';

// Global alerts
export const GET_HIERARCHY_LEVEL_ALERTS = 'GET_WORKSPACE_ALERTS';
export const GET_HIERARCHY_LEVEL_ALERTS_SUCCESS = 'GET_WORKSPACE_ALERTS_SUCCESS';
export const GET_HIERARCHY_LEVEL_ALERTS_FAILURE = 'GET_WORKSPACE_ALERTS_FAILURE';

// Persist hierarchy table state
export const PERSIST_HIERARCHY_TABLE = 'PERSIST_HIERARCHY_TABLE';
export const CLEAN_HIERARCHY_TABLE = 'CLEAN_HIERARCHY_TABLE';

export const CLEAN_PERSIST_HIERARCHY_TABLE = 'CLEAN_PERSIST_HIERARCHY_TABLE';

// ---------------
// Get Organizations
// ---------------
const getOrganizationsData = (): CommonActionType => ({
  type: GET_ORGANIZATIONS_DATA,
});

const getOrganizationsDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ORGANIZATIONS_DATA_FAILURE,
  payload: error,
});

const getOrganizationsDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadOrganizationsType>> => ({
  type: GET_ORGANIZATIONS_DATA_SUCCESS,
  payload: storeData,
});

export const loadOrganizations =
  (offset = 0, limit = 1000): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadOrganizationsType> => {
    dispatch(getOrganizationsData());
    const userEmailId = dataCache.get('currentUser')?.id;

    return HierarchiesAPI.getOrganizationsAPI(userEmailId, offset, limit)
      .then(
        (entityTypes): ReturnType<any> =>
          filterUserResourcesToArray(entityTypes, dataCache, RESOURCE_TYPES.ORGANIZATION)
      )
      .then(responseJson => {
        dispatch(getOrganizationsDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getOrganizationsDataFailure(error));
      });
  };

// ---------------
// Get Organizations by org id
// ---------------
const getOrganizationByIdData = (): CommonActionType => ({
  type: GET_ORGANIZATION_BY_ID_DATA,
});

const getOrganizationByIdDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ORGANIZATION_BY_ID_DATA_FAILURE,
  payload: error,
});

const getOrganizationByIdDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadOrganizationByIdType>> => ({
  type: GET_ORGANIZATION_BY_ID_DATA_SUCCESS,
  payload: storeData,
});

export const loadOrganizationById =
  (orgId: string): AppThunk =>
  (dispatch): ReturnType<LoadOrganizationByIdType> => {
    dispatch(getOrganizationByIdData());
    return HierarchiesAPI.getOrganizationByIdAPI(orgId)
      .then(responseJson => {
        dispatch(getOrganizationByIdDataSuccess([responseJson] || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getOrganizationByIdDataFailure(error));
      });
  };

// ---------------
// Get Sites for specific Organizations
// ---------------
const getSitesForOrganizationData = (): CommonActionType => ({
  type: GET_SITES_FOR_ORGANIZATION_DATA,
});

const getSitesForOrganizationDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_SITES_FOR_ORGANIZATION_DATA_FAILURE,
  payload: error,
});

const getSitesForOrganizationDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSitesForOrganizationType>> => ({
  type: GET_SITES_FOR_ORGANIZATION_DATA_SUCCESS,
  payload: storeData,
});

export const loadSitesForOrganization =
  (orgId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadSitesForOrganizationType> => {
    dispatch(getSitesForOrganizationData());
    return HierarchiesAPI.getSitesForOrganizationAPI(orgId)
      .then(
        (entityTypes): ReturnType<any> =>
          filterUserResourcesToArray(entityTypes, dataCache, RESOURCE_TYPES.SITE)
      )
      .then(responseJson => {
        dispatch(getSitesForOrganizationDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getSitesForOrganizationDataFailure(error));
      });
  };

// ---------------
// Get site
// ---------------
const getSiteData = (): CommonActionType => ({
  type: GET_SITE_DATA,
});

const getSiteDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_SITE_DATA_FAILURE,
  payload: error,
});

const getSiteDataSuccess = (storeData): CommonActionType<ReturnType<LoadSiteByIdType>> => ({
  type: GET_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadSiteById =
  (siteId: string): AppThunk =>
  (dispatch): ReturnType<LoadSiteByIdType> => {
    dispatch(getSiteData());
    return HierarchiesAPI.getSiteByIdAPI(siteId)
      .then(responseJson => {
        dispatch(getSiteDataSuccess([responseJson] || {}));
        return responseJson;
      })
      .catch(error => {
        dispatch(getSiteDataFailure(error));
      });
  };

// ---------------
// Get systems for specific site
// ---------------
const getSystemsForSiteData = (): CommonActionType => ({
  type: GET_SYSTEMS_FOR_SITE_DATA,
});

const getSystemsForSiteDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_SYSTEMS_FOR_SITE_DATA_FAILURE,
  payload: error,
});

const getSystemsForSiteDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSystemsForSiteType>> => ({
  type: GET_SYSTEMS_FOR_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadSystemsForSite =
  (siteId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadSystemsForSiteType> => {
    dispatch(getSystemsForSiteData());
    return HierarchiesAPI.getSystemsForSiteAPI(siteId)
      .then(entityTypes =>
        filterUserResourcesToArray(entityTypes, dataCache, RESOURCE_TYPES.SYSTEM)
      )
      .then(responseJson => {
        dispatch(getSystemsForSiteDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getSystemsForSiteDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get systems for specific site and location
// ---------------
const getSystemsForSiteLocationData = (): CommonActionType => ({
  type: GET_SYSTEMS_FOR_SITE_LOCATION_DATA,
});

const getSystemsForSiteLocationDataFailure = (error): CommonActionType<ErrorType> => ({
  payload: error,
  type: GET_SYSTEMS_FOR_SITE_LOCATION_DATA_FAILURE,
});

const getSystemsForSiteLocationDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSystemsForSiteLocationType>> => ({
  payload: storeData,
  type: GET_SYSTEMS_FOR_SITE_LOCATION_DATA_SUCCESS,
});

export const loadSystemsForSiteLocation =
  (siteId: string, locationId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadSystemsForSiteLocationType> => {
    dispatch(getSystemsForSiteLocationData());
    return HierarchiesAPI.getSystemsForSiteLocation(siteId, locationId)
      .then(responseJson =>
        filterUserResourcesToArray(responseJson, dataCache, RESOURCE_TYPES.SYSTEM)
      )
      .then((responseJson): ReturnType<any> => {
        dispatch(
          getSystemsForSiteLocationDataSuccess(responseJson || { results: [], totalCount: 0 })
        );
        return responseJson;
      })
      .catch(error => {
        dispatch(getSystemsForSiteLocationDataFailure(error));
      });
  };

// ---------------
// Get locations for specific site
// ---------------
const getLocationsForSiteData = (): CommonActionType => ({
  type: GET_LOCATIONS_FOR_SITE_DATA,
});

const getLocationsForSiteDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_LOCATIONS_FOR_SITE_DATA_FAILURE,
  payload: error,
});

const getLocationsForSiteDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadLocationsForSiteType>> => ({
  type: GET_LOCATIONS_FOR_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadLocationsForSite =
  (siteId: string): AppThunk =>
  (dispatch, getData, { dataCache }): ReturnType<LoadLocationsForSiteType> => {
    dispatch(getLocationsForSiteData());
    return HierarchiesAPI.getLocationsForSiteAPI(siteId)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.LOCATION)
      )
      .then(responseJson => {
        dispatch(getLocationsForSiteDataSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getLocationsForSiteDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get system data for specific id and for specific site
// ---------------
const getSystemForSiteData = (): CommonActionType => ({
  type: GET_SYSTEM_BY_ID_FOR_SITE_DATA,
});

const getSystemForSiteDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_SYSTEM_BY_ID_FOR_SITE_DATA_FAILURE,
  payload: error,
});

const getSystemForSiteDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSystemByIdForSiteType>> => ({
  type: GET_SYSTEM_BY_ID_FOR_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadSystemByIdForSite =
  (siteId: string, systemId: string): AppThunk =>
  (dispatch): ReturnType<LoadSystemByIdForSiteType> => {
    dispatch(getSystemForSiteData());
    return HierarchiesAPI.getSystemByIdForSite(siteId, systemId)
      .then(responseJson => {
        dispatch(getSystemForSiteDataSuccess([responseJson] || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getSystemForSiteDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get locations for specific site and system
// ---------------
const getLocationsForSystemData = (): CommonActionType => ({
  type: GET_LOCATIONS_FOR_SYSTEM_DATA,
});

const getLocationsForSystemDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_LOCATIONS_FOR_SYSTEM_DATA_FAILURE,
  payload: error,
});

const getLocationsForSystemDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadLocationsForSystemType>> => ({
  type: GET_LOCATIONS_FOR_SYSTEM_DATA_SUCCESS,
  payload: storeData,
});

export const loadLocationsForSystem =
  (siteId: string, systemId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadLocationsForSystemType> => {
    dispatch(getLocationsForSystemData());
    return HierarchiesAPI.getLocationsForSystem(siteId, systemId)
      .then(entityTypes =>
        filterUserResourcesToArray(entityTypes, dataCache, RESOURCE_TYPES.LOCATION)
      )
      .then(responseJson => {
        dispatch(getLocationsForSystemDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getLocationsForSystemDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get locations by it for specific site
// ---------------
const getLocationsByIdData = (): CommonActionType => ({
  type: GET_LOCATION_BY_ID_FOR_SITE_DATA,
});

const getLocationsByIdDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_LOCATION_BY_ID_FOR_SITE_DATA_FAILURE,
  payload: error,
});

const getLocationsByIdDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadLocationByIdForSiteType>> => ({
  type: GET_LOCATION_BY_ID_FOR_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadLocationByIdForSite =
  (siteId: string, locationId: string): AppThunk =>
  (dispatch): ReturnType<LoadLocationByIdForSiteType> => {
    dispatch(getLocationsByIdData());
    return HierarchiesAPI.getLocationByIdForSiteAPI(siteId, locationId)
      .then(responseJson => {
        dispatch(getLocationsByIdDataSuccess([responseJson] || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getLocationsByIdDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get parent locations for location
// ---------------
const getParentLocationsForLocationData = (): CommonActionType => ({
  type: GET_PARENT_LOCATIONS_FOR_LOCATION_DATA,
});

const getParentLocationsForLocationFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_PARENT_LOCATIONS_FOR_LOCATION_DATA_FAILURE,
  payload: error,
});

const getParentLocationsForLocationSuccess = (
  storeData
): CommonActionType<ReturnType<LoadParentLocationsForLocationType>> => ({
  type: GET_PARENT_LOCATIONS_FOR_LOCATION_DATA_SUCCESS,
  payload: storeData,
});

const clearParentLocations = (): CommonActionType => ({
  type: CLEAR_PARENT_LOCATIONS,
});

export const loadParentLocationsForLocation =
  (siteId: string, systemId: string, locationId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadParentLocationsForLocationType> => {
    dispatch(clearParentLocations());
    dispatch(getParentLocationsForLocationData());
    return HierarchiesAPI.getParentLocationForLocation(siteId, systemId, locationId)
      .then(entityTypes =>
        filterUserResourcesToArray(entityTypes, dataCache, RESOURCE_TYPES.LOCATION)
      )
      .then((responseJson): ReturnType<any> => {
        dispatch(getParentLocationsForLocationSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getParentLocationsForLocationFailure(error));
        throw error;
      });
  };

// ---------------
// Get sublocations for specific site and system and location
// ---------------
const getSublocationsForSystemData = (): CommonActionType => ({
  type: GET_SUBLOCATIONS_FOR_SYSTEM_DATA,
});

const getSublocationsForSystemDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_SUBLOCATIONS_FOR_SYSTEM_DATA_FAILURE,
  payload: error,
});

const getSublocationsForSystemDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSublocationsForSystemType>> => ({
  type: GET_SUBLOCATIONS_FOR_SYSTEM_DATA_SUCCESS,
  payload: storeData?.results,
});

export const loadSublocationsForSystem =
  (siteId: string, systemId: string, locationId: string, page = 0, limit = 1000): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadSublocationsForSystemType> => {
    dispatch(getSublocationsForSystemData());
    return HierarchiesAPI.getSublocationsForSystem(siteId, systemId, locationId, page, limit)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.LOCATION)
      )
      .then(responseJson => {
        dispatch(getSublocationsForSystemDataSuccess(responseJson || {}));
        return responseJson;
      })
      .catch(error => {
        dispatch(getSublocationsForSystemDataFailure(error));
      });
  };

// ---------------
// Get asset types
// ---------------
const getAssetTypesData = (): CommonActionType => ({
  type: GET_ASSET_TYPES_DATA,
});

const getAssetTypesDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ASSET_TYPES_DATA_FAILURE,
  payload: error,
});

const getAssetTypesDataSuccess = (storeData): CommonActionType<ReturnType<LoadAssetTypesType>> => ({
  type: GET_ASSET_TYPES_DATA_SUCCESS,
  payload: storeData,
});

export const loadAssetTypes =
  (): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadAssetTypesType> => {
    dispatch(getAssetTypesData());
    const userEmailId = dataCache.get('currentUser')?.id;

    return HierarchiesAPI.getAssetTypes(userEmailId)
      .then(entityTypes =>
        filterUserResourcesToArray(entityTypes, dataCache, RESOURCE_TYPES.ASSET_TYPE)
      )
      .then(responseJson => {
        dispatch(getAssetTypesDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getAssetTypesDataFailure(error));
      });
  };

// ---------------
// Get assets for specific asset type
// ---------------
const getAssetsForAssetTypeData = (): CommonActionType => ({
  type: GET_ASSETS_FOR_ASSET_TYPE_DATA,
});

const getAssetsForAssetTypeDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ASSETS_FOR_ASSET_TYPE_DATA_FAILURE,
  payload: error,
});

const getAssetsForAssetTypeDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadAssetsForAssetTypeType>> => ({
  type: GET_ASSETS_FOR_ASSET_TYPE_DATA_SUCCESS,
  payload: storeData,
});

export const loadAssetsForAssetType =
  (assetTypeId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadAssetsForAssetTypeType> => {
    dispatch(getAssetsForAssetTypeData());
    const userEmailId = dataCache.get('currentUser')?.id;

    return HierarchiesAPI.getAssetsForAssetType(assetTypeId, userEmailId)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.ASSET)
      )
      .then(responseJson => {
        dispatch(getAssetsForAssetTypeDataSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getAssetsForAssetTypeDataFailure(error));
      });
  };

// ---------------
// Get assets for specific site and location
// ---------------
const getAssetsForSiteLocationData = (): CommonActionType => ({
  type: GET_ASSETS_FOR_LOCATION_DATA,
});

const getAssetsForSiteLocationDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ASSETS_FOR_LOCATION_DATA_FAILURE,
  payload: error,
});

const getAssetsForSiteLocationDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadAssetForSiteLocationType>> => ({
  type: GET_ASSETS_FOR_LOCATION_DATA_SUCCESS,
  payload: storeData,
});

export const loadAssetForSiteLocation =
  (siteId: string, locationId: string, page: number, limit: number): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadAssetForSiteLocationType> => {
    dispatch(getAssetsForSiteLocationData());

    return HierarchiesAPI.getAssetsForSiteLocation(siteId, locationId, page, limit)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.ASSET)
      )
      .then(responseJson => {
        dispatch(
          getAssetsForSiteLocationDataSuccess(responseJson || { results: [], totalCount: 0 })
        );
        return responseJson;
      })
      .catch(error => {
        dispatch(getAssetsForSiteLocationDataFailure(error));
      });
  };

// ---------------
// Get assets for specific site only
// ---------------
const getAssetsForSiteData = (): CommonActionType => ({
  type: GET_ASSETS_FOR_SITE_DATA,
});

const getAssetsForSiteDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ASSETS_FOR_SITE_DATA_FAILURE,
  payload: error,
});

const getAssetsForSiteDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadAssetsForSiteType>> => ({
  type: GET_ASSETS_FOR_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadAssetsForSite =
  (siteId: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadAssetsForSiteType> => {
    dispatch(getAssetsForSiteData());
    return HierarchiesAPI.getAssetsForSiteAPI(siteId)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.ASSET)
      )
      .then(responseJson => {
        dispatch(getAssetsForSiteDataSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getAssetsForSiteDataFailure(error));
      });
  };

// ---------------
// Get assets by id for specific site
// ---------------
const getAssetsByIdData = (): CommonActionType => ({
  type: GET_ASSET_BY_ID_FOR_SITE_DATA,
});

const getAssetsByIdDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_ASSET_BY_ID_FOR_SITE_DATA_FAILURE,
  payload: error,
});

const getAssetsByIdDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadAssetByIdForSite>> => ({
  type: GET_ASSET_BY_ID_FOR_SITE_DATA_SUCCESS,
  payload: storeData,
});

export const loadAssetByIdForSite =
  (siteId: string, assetId: string): AppThunk =>
  (dispatch): ReturnType<LoadAssetByIdForSite> => {
    dispatch(getAssetsByIdData());
    return HierarchiesAPI.getAssetByIdForSiteAPI(siteId, assetId)
      .then(responseJson => {
        dispatch(getAssetsByIdDataSuccess([responseJson] || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getAssetsByIdDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get parent assets for asset
// ---------------
const getParentAssetsForAssetData = (): CommonActionType => ({
  type: GET_PARENT_ASSETS_FOR_ASSET_DATA,
});

const getParentAssetsForAssetFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_PARENT_ASSETS_FOR_ASSET_DATA_FAILURE,
  payload: error,
});

const getParentAssetsForAssetSuccess = (
  storeData
): CommonActionType<ReturnType<LoadParentAssetsForAssetType>> => ({
  type: GET_PARENT_ASSETS_FOR_ASSET_DATA_SUCCESS,
  payload: storeData,
});

const clearParentAssets = (): CommonActionType => ({
  type: CLEAR_PARENT_ASSETS,
});

export const loadParentAssetsForAsset =
  (siteId: string, assetId: string): AppThunk =>
  (dispatch): ReturnType<LoadParentAssetsForAssetType> => {
    dispatch(clearParentAssets());
    dispatch(getParentAssetsForAssetData());
    return HierarchiesAPI.getParentAssetsForAsset(siteId, assetId)
      .then(responseJson => {
        dispatch(getParentAssetsForAssetSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getParentAssetsForAssetFailure(error));
        throw error;
      });
  };

// ---------------
// Get child assets for asset
// ---------------
const getSubAssetsForAssetData = (): CommonActionType => ({
  type: GET_SUBASSETS_FOR_ASSET_DATA,
});

const getSubAssetsForAssetFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_SUBASSETS_FOR_ASSET_DATA_FAILURE,
  payload: error,
});

const getSubAssetsForAssetSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSubAssetsForAssetType>> => ({
  type: GET_SUBASSETS_FOR_ASSET_DATA_SUCCESS,
  payload: storeData,
});

const clearSubAssets = (): CommonActionType => ({
  type: CLEAR_SUBASSETS,
});

export const loadSubAssetsForAsset =
  (siteId: string, assetId: string, page = 0, limit = 100): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadSubAssetsForAssetType> => {
    dispatch(clearSubAssets());
    dispatch(getSubAssetsForAssetData());
    return HierarchiesAPI.getSubAssetsForAsset(siteId, assetId, page, limit)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.ASSET)
      )
      .then(responseJson => {
        dispatch(getSubAssetsForAssetSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getSubAssetsForAssetFailure(error));
      });
  };

// ---------------
// Get devices for asset
// ---------------
const getDevicesForAssetData = (): CommonActionType => ({
  type: GET_DEVICES_FOR_ASSET_DATA,
});

const getDevicesForAssetDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICES_FOR_ASSET_DATA_FAILURE,
  payload: error,
});

const getDevicesForAssetDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadSubAssetsForAssetType>> => ({
  type: GET_DEVICES_FOR_ASSET_DATA_SUCCESS,
  payload: storeData,
});

export const loadDevicesForAsset =
  (siteId: string, assetId: string, page = 0, limit = 100): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadDevicesForAssetType> => {
    dispatch(clearSubAssets());
    dispatch(getDevicesForAssetData());
    return HierarchiesAPI.getDevicesForAsset(siteId, assetId, page, limit)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.DEVICE, assetId)
      )
      .then(responseJson => {
        dispatch(getDevicesForAssetDataSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDevicesForAssetDataFailure(error));
        throw error;
      });
  };

// ---------------
// Get device types
// ---------------
const getDeviceTypesData = (): CommonActionType => ({
  type: GET_DEVICE_TYPES_DATA,
});

const getDeviceTypesDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICE_TYPES_DATA_FAILURE,
  payload: error,
});

const getDeviceTypesDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDeviceTypesType>> => ({
  type: GET_DEVICE_TYPES_DATA_SUCCESS,
  payload: storeData,
});

export const loadDeviceTypes =
  (limit = 1000, body = {}, offset = 0): AppThunk<ReturnType<LoadDeviceTypesType>> =>
  (dispatch, getState, { dataCache }): ReturnType<LoadDeviceTypesType> => {
    dispatch(getDeviceTypesData());
    const userEmailId = dataCache.get('currentUser')?.id;

    return HierarchiesAPI.getDeviceTypesAPI(userEmailId, body, offset, limit)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.DEVICE_TYPE)
      )
      .then(responseJson => {
        dispatch(getDeviceTypesDataSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDeviceTypesDataFailure(error));
      });
  };

// ---------------
// Get details for specific device type
// ---------------
const getDeviceTypeData = (): CommonActionType => ({
  type: GET_DEVICE_TYPE_DATA,
});

const getDeviceTypeDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICE_TYPE_DATA_FAILURE,
  payload: error,
});

const getDeviceTypeDataSuccess = (storeData): CommonActionType<ReturnType<LoadDeviceTypeById>> => ({
  type: GET_DEVICE_TYPE_DATA_SUCCESS,
  payload: storeData,
});

export const loadDeviceTypeById =
  (deviceTypeId: string): AppThunk =>
  (dispatch): ReturnType<LoadDeviceTypeById> => {
    dispatch(getDeviceTypeData());
    return HierarchiesAPI.getDeviceTypeByIdAPI(deviceTypeId)
      .then(responseJson => {
        dispatch(getDeviceTypeDataSuccess([responseJson] || {}));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDeviceTypeDataFailure(error));
      });
  };

// ---------------
// Update device type
// ---------------
const updateV1DeviceTypeData = (): CommonActionType => ({
  type: UPDATE_DEVICE_TYPE_DATA,
});

const updateV1DeviceTypeDataFailure = (error: I18NErrorType): CommonActionType<I18NErrorType> => ({
  type: UPDATE_DEVICE_TYPE_DATA_FAILURE,
  payload: error,
});

const updateV1DeviceTypeDataSuccess = (
  storeData
): CommonActionType<ReturnType<UpdateV1DeviceTypeType>> => ({
  type: UPDATE_DEVICE_TYPE_DATA_SUCCESS,
  payload: storeData,
});

export const updateV1DeviceType =
  (deviceTypeId: string, deviceTypeData: DeviceTypeResourceType): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<UpdateV1DeviceTypeType> => {
    dispatch(updateV1DeviceTypeData());
    const userEmailId = dataCache.get('currentUser')?.id;

    return HierarchiesAPI.updateV1DeviceTypeAPI(deviceTypeId, deviceTypeData, userEmailId)
      .then(responseJson => {
        dispatch(updateV1DeviceTypeDataSuccess([responseJson] || {}));
        return responseJson;
      })
      .catch(error => {
        dispatch(updateV1DeviceTypeDataFailure(error));
        throw error;
      });
  };

// ---------------
// Update device alias
// ---------------
const updateDeviceAliasStart = (): CommonActionType => ({
  type: UPDATE_DEVICE_ALIAS,
});

const updateDeviceAliasFailure = (error): CommonActionType<ErrorType> => ({
  type: UPDATE_DEVICE_ALIAS_FAILURE,
  payload: error,
});

const updateDeviceAliasSuccess = (
  storeData
): CommonActionType<ReturnType<UpdateDeviceAliasType>> => ({
  type: UPDATE_DEVICE_ALIAS_SUCCESS,
  payload: storeData,
});

export const updateDeviceAlias =
  (deviceTypeId: string, deviceId: string, alias: string): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<UpdateDeviceAliasType> => {
    dispatch(updateDeviceAliasStart());
    const userEmailId = dataCache.get('currentUser')?.id;

    return HierarchiesAPI.updateDeviceAlias(deviceTypeId, deviceId, alias, userEmailId)
      .then(responseJson => {
        dispatch(updateDeviceAliasSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(updateDeviceAliasFailure(error));
        throw error;
      });
  };

// ---------------
// Get devices for specific device type
// ---------------
const getDevicesForDeviceTypeData = (): CommonActionType => ({
  type: GET_DEVICES_FOR_DEVICE_TYPE_DATA,
});

const getDevicesForDeviceTypeDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE,
  payload: error,
});

const getDevicesForDeviceTypeDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDevicesForDeviceTypeType>> => ({
  type: GET_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS,
  payload: storeData,
});

export const loadDevicesForDeviceType =
  (deviceTypeId: string, limit = 1000, page = 0, deviceId = null): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadDevicesForDeviceTypeType> => {
    dispatch(getDevicesForDeviceTypeData());
    return HierarchiesAPI.getDevicesForDeviceType(deviceTypeId, page, limit, deviceId)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.DEVICE, deviceTypeId)
      )
      .then(responseJson => {
        dispatch(
          getDevicesForDeviceTypeDataSuccess(responseJson || { results: [], totalCount: 0 })
        );
        return responseJson;
      })
      .catch(error => {
        dispatch(getDevicesForDeviceTypeDataFailure(error));
      });
  };

// ---------------
// Get dimensions for specific device type
// ---------------
const getDimensionsForDeviceTypeData = (): CommonActionType => ({
  type: GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA,
});

const getDimensionsForDeviceTypeDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_FAILURE,
  payload: error,
});

const getDimensionsForDeviceTypeDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDimensionsForDeviceTypeType>> => ({
  type: GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_SUCCESS,
  payload: storeData,
});

export const loadDimensionsForDeviceType =
  (deviceTypeId: string): AppThunk =>
  (dispatch): ReturnType<LoadDimensionsForDeviceTypeType> => {
    dispatch(getDimensionsForDeviceTypeData());
    return HierarchiesAPI.getDimensionsForDeviceType(deviceTypeId)
      .then(responseJson => {
        dispatch(getDimensionsForDeviceTypeDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDimensionsForDeviceTypeDataFailure(error));
      });
  };

// ---------------
// Update dimensions for specific device type
// ---------------
const updateDimensionsForDeviceTypeStart = (): CommonActionType => ({
  type: UPDATE_DIMENSIONS_FOR_DEVICE_TYPE,
});

const updateDimensionsForDeviceTypeFailure = (
  error: I18NErrorType
): CommonActionType<I18NErrorType> => ({
  type: UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE,
  payload: error,
});

const updateDimensionsForDeviceTypeSuccess = (
  storeData
): CommonActionType<ReturnType<UpdateDimensionsForDeviceTypeType>> => ({
  type: UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS,
  payload: storeData,
});

export const updateDimensionsForDeviceType =
  (deviceTypeId: string, dimensions: DimensionsType, overrideExistingValue: boolean): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<UpdateDimensionsForDeviceTypeType> => {
    dispatch(updateDimensionsForDeviceTypeStart());
    return HierarchiesAPI.updateDimensionsForDeviceType(
      deviceTypeId,
      dimensions,
      overrideExistingValue,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(updateDimensionsForDeviceTypeSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(updateDimensionsForDeviceTypeFailure(error));
        throw error;
      });
  };

// ---------------
// Delete dimensions for specific device type
// ---------------
const deleteDimensionsForDeviceTypeStart = (): CommonActionType => ({
  type: DELETE_DIMENSIONS_FOR_DEVICE_TYPE,
});

const deleteDimensionsForDeviceTypeFailure = (
  error: I18NErrorType
): CommonActionType<I18NErrorType> => ({
  type: DELETE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE,
  payload: error,
});

const deleteDimensionsForDeviceTypeSuccess = (
  storeData
): CommonActionType<ReturnType<DeleteDimensionsForDeviceTypeType>> => ({
  type: DELETE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS,
  payload: storeData,
});

export const deleteDimensionsForDeviceType =
  (deviceTypeId: string, dimensions: Array<string>): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<DeleteDimensionsForDeviceTypeType> => {
    dispatch(deleteDimensionsForDeviceTypeStart());
    return HierarchiesAPI.deleteDimensionsForDeviceType(
      deviceTypeId,
      dimensions,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(deleteDimensionsForDeviceTypeSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(deleteDimensionsForDeviceTypeFailure(error));
        throw error;
      });
  };

// ---------------
// Add dimensions for specific device type
// ---------------
const addDimensionsForDeviceTypeStart = (): CommonActionType => ({
  type: CREATE_DIMENSIONS_FOR_DEVICE_TYPE,
});

const addDimensionsForDeviceTypeFailure = (
  error: I18NErrorType
): CommonActionType<I18NErrorType> => ({
  type: CREATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE,
  payload: error,
});

const addDimensionsForDeviceTypeSuccess = (
  storeData
): CommonActionType<ReturnType<AddDimensionsForDeviceTypeType>> => ({
  type: CREATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS,
  payload: storeData,
});

export const addDimensionsForDeviceType =
  (deviceTypeId: string, dimensions: DimensionsType): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<AddDimensionsForDeviceTypeType> => {
    dispatch(addDimensionsForDeviceTypeStart());
    return HierarchiesAPI.createDimensionsForDeviceType(
      deviceTypeId,
      dimensions,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(addDimensionsForDeviceTypeSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(addDimensionsForDeviceTypeFailure(error));
        throw error;
      });
  };

// ---------------
// Add device for specific device type
// ---------------
const addDevicesForDeviceTypeStart = (): CommonActionType => ({
  type: CREATE_DEVICES_FOR_DEVICE_TYPE_DATA,
});

const addDevicesForDeviceTypeFailure = (error: I18NErrorType): CommonActionType<I18NErrorType> => ({
  type: CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE,
  payload: error,
});

const addDevicesForDeviceTypeSuccess = (
  storeData
): CommonActionType<ReturnType<AddDevicesForDeviceTypeType>> => ({
  type: CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS,
  payload: storeData,
});

export const addDevicesForDeviceType =
  (deviceTypeUUID: string, devices: AddDevicesPayloadType): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<AddDevicesForDeviceTypeType> => {
    dispatch(addDevicesForDeviceTypeStart());
    const userEmailId = dataCache.get('currentUser')?.id;
    return createDevicesForDeviceTypeAPI(deviceTypeUUID, devices, userEmailId)
      .then(responseJson => {
        dispatch(addDevicesForDeviceTypeSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(addDevicesForDeviceTypeFailure(error));
        throw error;
      });
  };

// ---------------
// Update v2 device type payloads
// ---------------
const updateV2DeviceTypeStart = (): CommonActionType => ({
  type: UPDATE_METRICS_FOR_DEVICE_TYPE,
});

const updateV2DeviceTypeFailure = (error: I18NErrorType): CommonActionType<I18NErrorType> => ({
  type: UPDATE_METRICS_FOR_DEVICE_TYPE_FAILURE,
  payload: error,
});

const updateV2DeviceTypeSuccess = (
  storeData
): CommonActionType<ReturnType<UpdateV2DeviceTypeType>> => ({
  type: UPDATE_METRICS_FOR_DEVICE_TYPE_SUCCESS,
  payload: storeData,
});

export const updateV2DeviceType =
  (deviceTypeUUID: string, deviceTypeData: EntityType): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<UpdateV2DeviceTypeType> => {
    dispatch(updateV2DeviceTypeStart());
    return HierarchiesAPI.updateV2DeviceTypeAPI(
      deviceTypeUUID,
      deviceTypeData,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(updateV2DeviceTypeSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(updateV2DeviceTypeFailure(error));
        throw error;
      });
  };

// ---------------
// Delete metrics for specific device type
// ---------------
const deleteMetricsForDeviceTypeStart = (): CommonActionType => ({
  type: DELETE_METRICS_FOR_DEVICE_TYPE,
});

const deleteMetricsForDeviceTypeFailure = (
  error: I18NErrorType
): CommonActionType<I18NErrorType> => ({
  type: DELETE_METRICS_FOR_DEVICE_TYPE_FAILURE,
  payload: error,
});

const deleteMetricsForDeviceTypeSuccess = (
  storeData
): CommonActionType<ReturnType<DeleteMetricsForDeviceTypeType>> => ({
  type: DELETE_METRICS_FOR_DEVICE_TYPE_SUCCESS,
  payload: storeData,
});

export const deleteMetricsForV2DeviceType =
  (deviceTypeUUID: string, dataItemsIds: Array<string>): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<DeleteMetricsForDeviceTypeType> => {
    dispatch(deleteMetricsForDeviceTypeStart());
    return HierarchiesAPI.deleteMetricsForV2DeviceType(
      deviceTypeUUID,
      dataItemsIds,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(deleteMetricsForDeviceTypeSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(deleteMetricsForDeviceTypeFailure(error));
        throw error;
      });
  };

// ---------------
// Update dimensions for specific device
// ---------------
const updateDimensionsForDeviceStart = (): CommonActionType => ({
  type: UPDATE_DIMENSIONS_FOR_DEVICE,
});

const updateDimensionsForDeviceFailure = (
  error: I18NErrorType
): CommonActionType<I18NErrorType> => ({
  type: UPDATE_DIMENSIONS_FOR_DEVICE_FAILURE,
  payload: error,
});

const updateDimensionsForDeviceSuccess = (
  storeData
): CommonActionType<ReturnType<UpdateDimensionsForDeviceType>> => ({
  type: UPDATE_DIMENSIONS_FOR_DEVICE_SUCCESS,
  payload: storeData,
});

export const updateDimensionsForDevice =
  (deviceTypeId: string, dimensions: DimensionsType): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<UpdateDimensionsForDeviceType> => {
    dispatch(updateDimensionsForDeviceStart());
    return HierarchiesAPI.updateDimensionsForDevice(
      deviceTypeId,
      dimensions,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(updateDimensionsForDeviceSuccess(responseJson));
        return responseJson;
      })
      .catch(error => {
        dispatch(updateDimensionsForDeviceFailure(error));
      });
  };

// ---------------
// Add dimensions for specific device
// ---------------
const addDimensionsForDeviceStart = (): CommonActionType => ({
  type: CREATE_DIMENSIONS_FOR_DEVICE,
});

const addDimensionsForDeviceFailure = (error: I18NErrorType): CommonActionType<I18NErrorType> => ({
  type: CREATE_DIMENSIONS_FOR_DEVICE_FAILURE,
  payload: error,
});

const addDimensionsForDeviceSuccess = (
  storeData
): CommonActionType<ReturnType<AddDimensionsForDeviceType>> => ({
  type: CREATE_DIMENSIONS_FOR_DEVICE_SUCCESS,
  payload: storeData,
});

// TODO: Please remove this. Adding dimension to device is not possible. you can only update device dimensions.
export const addDimensionsForDevice =
  (deviceTypeId: string, dimensions: DimensionsType): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<AddDimensionsForDeviceType> => {
    dispatch(addDimensionsForDeviceStart());
    return HierarchiesAPI.createDimensionsForDevice(
      deviceTypeId,
      dimensions,
      dataCache.get('currentUser')?.id
    )
      .then(responseJson => {
        dispatch(addDimensionsForDeviceSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(addDimensionsForDeviceFailure(error));
      });
  };

// ---------------
// Get dimensions for specific device
// ---------------
const getDimensionsForDeviceStart = (): CommonActionType => ({
  type: GET_DIMENSIONS_FOR_DEVICE,
});

const getDimensionsForDeviceFailure = (error: I18NErrorType): CommonActionType<I18NErrorType> => ({
  type: GET_DIMENSIONS_FOR_DEVICE_FAILURE,
  payload: error,
});

const getDimensionsForDeviceSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDimensionsForDeviceType>> => ({
  type: GET_DIMENSIONS_FOR_DEVICE_SUCCESS,
  payload: storeData,
});

export const getDimensionsForDevice =
  (hierarchyPath: string): AppThunk =>
  (dispatch): ReturnType<LoadDimensionsForDeviceType> => {
    dispatch(getDimensionsForDeviceStart());
    return HierarchiesAPI.getDimensionsForDeviceAPI(hierarchyPath)
      .then(responseJson => {
        dispatch(getDimensionsForDeviceSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDimensionsForDeviceFailure(error));
      });
  };

// ---------------
// Get devices for specific site and location
// ---------------
const getDevicesForLocationData = (): CommonActionType => ({
  type: GET_DEVICES_FOR_LOCATION_DATA,
});

const getDevicesForLocationDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICES_FOR_LOCATION_DATA_FAILURE,
  payload: error,
});

const getDevicesForLocationDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDevicesForLocationType>> => ({
  type: GET_DEVICES_FOR_LOCATION_DATA_SUCCESS,
  payload: storeData,
});

export const loadDevicesForLocation =
  (siteId: string, locationId: string, page = 0, limit = 1000): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadDevicesForLocationType> => {
    dispatch(getDevicesForLocationData());
    return HierarchiesAPI.getDevicesForLocation(siteId, locationId, page, limit)
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.DEVICE)
      )
      .then(responseJson => {
        dispatch(getDevicesForLocationDataSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDevicesForLocationDataFailure(error));
      });
  };

// ---------------
// Get details for a device
// ---------------
const getDeviceDetailsData = (): CommonActionType => ({
  type: GET_DEVICE_DETAILS_DATA,
});

const getDeviceDetailsDataFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICE_DETAILS_DATA_FAILURE,
  payload: error,
});

const getDeviceDetailsDataSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDeviceDetailsType>> => ({
  type: GET_DEVICE_DETAILS_DATA_SUCCESS,
  payload: storeData,
});

export const loadDeviceDetails =
  (deviceTypeId: string, deviceId: string): AppThunk =>
  (dispatch): ReturnType<LoadDeviceDetailsType> => {
    dispatch(getDeviceDetailsData());
    return getDeviceDetails(deviceTypeId, deviceId)
      .then(responseJson => {
        dispatch(getDeviceDetailsDataSuccess(responseJson || []));
        return responseJson;
      })
      .catch(error => {
        dispatch(getDeviceDetailsDataFailure(error));
      });
  };

// ---------------
// Clear hierarchies state
// ---------------
export const clearHierarchies = (): CommonActionType => ({
  type: CLEAR_HIERARCHIES,
});

export const clearAssetsForAssetType = (): CommonActionType => ({
  type: CLEAR_ASSETS_FOR_ASSET_TYPE,
});

export const clearDevicesForDeviceType = (): CommonActionType => ({
  type: CLEAR_DEVICES_FOR_DEVICE_TYPE,
});

// ----------------
// Load devices for a device type, with dimensions return in payload
// --------------------

const loadDevicesWithDimensions = (): CommonActionType => ({
  type: GET_DEVICE_DIMENSIONS_DATA,
});

const loadDevicesWithDimensionsFailure = (error): CommonActionType<ErrorType> => ({
  type: GET_DEVICE_DIMENSIONS_DATA_FAILURE,
  payload: error,
});

const loadDevicesWithDimensionsSuccess = (
  storeData
): CommonActionType<ReturnType<LoadDevicesWithDimensionsType>> => ({
  type: GET_DEVICE_DIMENSIONS_DATA_SUCCESS,
  payload: storeData,
});

export const loadDevicesForDeviceTypeWithDimensions =
  (deviceTypeId: string, limit: number, body = {}): AppThunk =>
  (dispatch, getState, { dataCache }): ReturnType<LoadDevicesWithDimensionsType> => {
    dispatch(loadDevicesWithDimensions());
    return getDeviceDetailsWithDimensions(
      deviceTypeId,
      limit,
      dataCache.get('currentUser')?.id,
      body
    )
      .then(responseJson =>
        filterUserResourcesToObject(responseJson, dataCache, RESOURCE_TYPES.DEVICE)
      )
      .then(responseJson => {
        dispatch(loadDevicesWithDimensionsSuccess(responseJson || { results: [], totalCount: 0 }));
        return responseJson;
      })
      .catch(error => {
        dispatch(loadDevicesWithDimensionsFailure(error));
      });
  };

// -------------
// PERSIST_HIERARCHY_TABLE
// ------------

const setHierarchyTable = (storeData): CommonActionType<Array<any>> => ({
  type: PERSIST_HIERARCHY_TABLE,
  payload: storeData,
});

export const persistHierarchyTable =
  ({
    tableData,
    expandedId,
    expanded,
  }: {
    tableData: any;
    expandedId: string;
    expanded: boolean;
  }): AppThunk =>
  (dispatch): ReturnType<PersistHierarchyTableType> | CommonActionType<Array<any>> =>
    dispatch(setHierarchyTable({ tableData, expandedId, expanded }));
export const cleanHierarchyTable = (): CommonActionType => ({
  type: CLEAN_PERSIST_HIERARCHY_TABLE,
});
